import React from "react";
const StockswithDot = (props) => {
    return (React.createElement("div", { className: "d-flex align-items-center gap-5-custom  txt_secondary-gray Roboto_12_400" },
        React.createElement("span", { className: "generic-stock-time" }, props.stockName),
        React.createElement("div", { className: "round-circle-search" },
            React.createElement("i", { className: "edel-icon-round-circle " })),
        !!props.subStockName && (React.createElement("span", { className: "generic-stock-date" }, props.subStockName))));
};
export default StockswithDot;
